/**
 * Seleção de OS no Board: exclusiva por coluna (Em aberto XOR um técnico).
 */

export function collectOrderIdsFromCityGroups(cityGroups) {
  const ids = new Set();
  if (!Array.isArray(cityGroups)) return ids;
  cityGroups.forEach((city) => {
    (city?.ordens || []).forEach((o) => {
      const id = o?.id ?? o?.TB02115_CODIGO;
      if (id != null && id !== '') ids.add(String(id));
    });
  });
  return ids;
}

export function collectOrderIdsFromTechnicianGroups(techData) {
  const ids = new Set();
  if (!techData || typeof techData !== 'object') return ids;
  Object.values(techData).forEach((arr) => {
    if (!Array.isArray(arr)) return;
    arr.forEach((o) => {
      const id = o?.id ?? o?.TB02115_CODIGO;
      if (id != null && id !== '') ids.add(String(id));
    });
  });
  return ids;
}

/**
 * Toggle de uma OS limitado ao escopo da coluna atual (descarta seleção de outra coluna).
 */
export function toggleOrderSelectionInColumnScope(prevSelected, orderId, scopeOrderIds) {
  const id = orderId != null && orderId !== '' ? String(orderId) : '';
  if (!id) return Array.isArray(prevSelected) ? [...prevSelected] : [];
  const scope = scopeOrderIds instanceof Set ? scopeOrderIds : new Set(scopeOrderIds || []);
  const prev = Array.isArray(prevSelected) ? prevSelected : [];
  const base = prev.filter((x) => scope.has(String(x)));
  if (base.some((x) => String(x) === id)) {
    return base.filter((x) => String(x) !== id);
  }
  return [...base, orderId];
}

/**
 * Marcar/desmarcar todas as OS de uma cidade (só no escopo Em aberto).
 */
export function toggleCityOrdersSelectionInOpenScope(prevSelected, cityOrderIds, openScopeOrderIds) {
  const cityList = Array.isArray(cityOrderIds) ? cityOrderIds : [];
  const scope = openScopeOrderIds instanceof Set ? openScopeOrderIds : new Set(openScopeOrderIds || []);
  const prev = Array.isArray(prevSelected) ? prevSelected : [];
  const base = prev.filter((x) => scope.has(String(x)));
  const allSelected =
    cityList.length > 0 && cityList.every((id) => base.some((x) => String(x) === String(id)));
  if (allSelected) {
    const citySet = new Set(cityList.map(String));
    return base.filter((x) => !citySet.has(String(x)));
  }
  const next = [...base];
  cityList.forEach((id) => {
    if (!next.some((x) => String(x) === String(id))) next.push(id);
  });
  return next;
}
